import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';
import { Platform, LoadingController, AlertController } from '@ionic/angular';
import { AttachmentService } from 'src/app/providers/forms/attachment/attachment.service';
import { CommonService } from 'src/app/providers/common/common.service';
import { UserDataService } from 'src/app/providers/userData/user-data.service';
import { FormStatusMapping } from '../../headerSection/header/form-status-mapping';

@Component({
  selector: 'app-attachment-picker-section',
  standalone: false,
  templateUrl: './attachment-picker-section.component.html',
  styleUrls: ['./attachment-picker-section.component.scss'],
})
export class AttachmentPickerSectionComponent implements OnInit {

  @Input() formId;
  @Input() formTypeId;
  @Input() formStatus;
  @Input() attachments;
  @Input() keyCaptionMap;
  @Input() createdByuserId;
  @Output() attachementEmmiter: EventEmitter<any> = new EventEmitter<any>();

  sectionOpen = false;
  caption = "";

  collegeManagementId;
  collegeId;
  userId;
  nativePath: any;
  imageData;
  returnpath: string = "";
  files: File[] = [];
  isMobileApp: boolean = false;
  loggedInUserId;
  attachmentsWithName = [];
  allowedUploadImage: boolean = false;
  isFROMIQACDASHBOARD: boolean = false
  exceedMaxLimit:boolean = false;
  profile:any = {};
  subscriptionStatus:boolean = true;
  constructor(
    public platform: Platform,
    public attachmentService: AttachmentService,
    public userdataService: UserDataService,
    public loadingController: LoadingController,
    public alertController: AlertController
  ) { }

  ngOnInit() {

    this.getProfile()
    this.userdataService.getCurrentActiveSection().then(section =>{
    if(section){
      if(section === 'IQAC_DASHBORAD'){
        this.isFROMIQACDASHBOARD = true;
      }else {
        this.isFROMIQACDASHBOARD = false;
      }
    }
  })
    this.formStatus.toString();
    this.userdataService.getUserProfile().then(profile => {
      if (profile) {
        this.loggedInUserId = profile.id        
        this.collegeId = profile.college.id;
        this.collegeManagementId = profile.college.managementCommittee.id;
        this.userId = profile.id;
        this.attachmentHandlingAllowed();
      }
    })
    if (this.platform.is('android')) {
      this.isMobileApp = true
    } else {
    }
    if (this.attachments === undefined) {
      this.attachments = [];
    }
    this.attachments.forEach((url, index) => {
      let attachmentWithUrl: any = {};
      attachmentWithUrl.url = url;
      attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(url);
      let key = this.deriveAttachmentKeyFromUrl(url);
      attachmentWithUrl.caption = this.keyCaptionMap[decodeURI(key)];
      attachmentWithUrl.key = key;
      this.attachmentsWithName.push(attachmentWithUrl);
    });
  }

  attachmentHandlingAllowed() {
    let status = this.formStatus;
    // if (this.attachmentsWithName.length < 2) {
    //   this.allowedUploadImage = true;
    // } else {
    //   this.allowedUploadImage = false;
    //   return;
    // }
    // if (this.allowedUploadImage) {
      if (this.createdByuserId === this.loggedInUserId) {
        if ((status === "REVERTED" || status === "RESENT" || status === "CREATED"
          || status === "RECALLED")) {
          this.allowedUploadImage = true;
        } else {
          this.allowedUploadImage = false;
        }
      } else if (this.createdByuserId != this.loggedInUserId && status === 'REVERTED') {
        this.allowedUploadImage = false;
      } else if (status === "SHARED" && this.createdByuserId != this.loggedInUserId) {
        this.allowedUploadImage = true;
      } else if (status === "SUBMITTED_FOR_APPROVAL" || status === "APPROVED" || status === "APPROVED_WITH_WebC"
        || status === "APPROVED_WITH_OFFICE_CO" || status === "APPROVED_WITH_WEB_AND_OFFICE"
        || status === "APPROVED_WITH_WebC_UPDATED" || status === "APPROVED_WITH_OFFICE_CO_UPDATED"
        || status === "APPROVED_WITH_WEB_AND_OFFICE_UPDATED" || status === "APPROVED_WITH_BOTH_OFFICE_UPDATED"
        || status === "APPROVED_WITH_BOTH_WebC_UPDATED") {
        this.allowedUploadImage = false;
      } else if (status === "SHARED_WITH_WebC" || status === "SHARED_WITH_OFFICE_CO" || status === "SHARED_WITH_WEB_AND_OFFICE") {
        this.allowedUploadImage = false;
      }
    // }
    if (this.attachmentsWithName.length >= 2) {
      // this.allowedUploadImage = true;
     this.exceedMaxLimit= true;
    }else {
      // this.allowedUploadImage = false;
      this.exceedMaxLimit= false;
      return ;
    }
  }

  async confirmRemove(url) {

    const loader = await this.loadingController.create({
      message: 'Deleting Attachment...'
    });
    loader.present();
    let payload: any = {}
    payload.managementCommitteeId = this.collegeManagementId
    payload.collageId = this.collegeId
    payload.userId = this.createdByuserId;
    payload.formTypeId = this.formTypeId;
    payload.formId = this.formId
    payload.fileName = this.deriveAttachmentNameFromUrl(url);
    this.attachmentService.delete(payload, 'REPORT_IMAGE')
      .subscribe(response => {
        if (response) {
          this.attachments.forEach((link, index) => {
            if (url === link) {
              this.attachments.splice(index, 1);
              this.attachementEmmiter.emit(this.attachments);
              console.log("emits handling",this.attachments)
            }
          });
          this.attachmentsWithName.forEach((attachment, index) => {
            if (url === attachment.url) {
              this.attachmentsWithName.splice(index, 1);
            }
          });
          this.attachmentHandlingAllowed();
          this.userdataService.presentToast("Attachment Removed and Form Updated Successfully.", "success");
          
        }
        loader.dismiss();
      }, error => {
        this.userdataService.presentToast("Attachment Removal Failed.", "danger");
        loader.dismiss();
      });
  }


  async editCaption(key, caption, attachment) {
    if (!this.attachmentHandlingAllowedDelete()) {
      this.userdataService.presentToast("You are not authorised to perform caption edit!", "warning")
      return false;
    }
    const alert = await this.alertController.create({
      header: "Edit Caption",
      message: "Please type image caption below",
      inputs: [{
        name: "caption",
        type: "textarea",
        value:caption
      }],
      buttons: [{
        text: "Save",
        role: "Ok",
        handler: (data) => {
          this.confirmEditCaption(key, data.caption);
          attachment.caption = data.caption;
        }
      },
      {
        text: "Cancel",
        role: "cancel",
        handler: () => {
          console.log("Cancel");
        }
      }
      ]
    })
    alert.present();
    return true;
  }

  async confirmEditCaption(key, captionText) {

    const loader = await this.loadingController.create({
      message: 'Saving image caption'
    });
    loader.present();
    let payload: any = {}
    payload.key = key;
    payload.caption = captionText
    this.attachmentService.editCaption(payload)
      .subscribe(response => {
        if (response) {
          
        }
        loader.dismiss();
      }, error => {
        this.userdataService.presentToast("Caption edit failed.", "danger");
        loader.dismiss();
      });
  }

  async remove(url) {
    if (!this.attachmentHandlingAllowedDelete()) {
      this.userdataService.presentToast("You are not authorised to perform attachment remove operations!", "warning")
      return;
    }
    const alert = await this.alertController.create({
      header: "Remove Attachment",
      message: "Do you want to remove this attachment?",
      cssClass: 'custom-alert-theme',
      backdropDismiss: false,
      buttons: [{
        text: "Yes",
        role: "confirm",
        cssClass: 'alert-button-confirm',
        handler: () => {
          this.confirmRemove(url);
          return true;
        }
      },
      {
        text: "Cancel",
        role: "cancel",
        cssClass: 'alert-button-cancel',
        handler: () => {
          console.log("Cancelled delete operation");
          return true;
        }
      }
      ]
    });
    await alert.present();
  }

  

  async onSelect(event) {
    console.log("Event added", event)
    CommonService.log(event)
    if (this.files.length > 0) {
      this.userdataService.presentToast("Only one Attachment file is supported to upload", "warning");
      return;
    } else {
      // Validate size
      /* if (event.addedFiles[0].size > 2000000) {
        this.userdataService.presentToast("Attachment size should not exceed 2MB", "warning");
        return;
      } */
      // Vaidate Type
      let type = event.addedFiles[0].type;

      if (_.includes(type, 'image/png') || _.includes(type, 'image/jpeg') || _.includes(type, 'image/jpg')) {
        this.files.push(...event.addedFiles);
      } else {
        this.userdataService.presentToast("Only png or jpeg images are allowed as Attachment", "warning");
        return;
      }
    }
  }

  onRemove(event) {
    CommonService.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  async uploadAttachment() {
    if(this.caption === undefined || this.caption === ""){
      this.userdataService.presentToast("Please add caption for attachment","warning");
      return false;
    }

    if(this.caption.length > 200){
      this.userdataService.presentToast("The field Caption must be a string with a maximum length of 200 characters","warning");
      return false;
    }
    const loader = await this.loadingController.create({
      message: 'Uploading Attachment...'
    });
    loader.present();
    let payload: any = {}
    payload.managementCommitteeId = this.collegeManagementId
    payload.collageId = this.collegeId
    payload.userId = this.createdByuserId;
    payload.formTypeId = this.formTypeId;
    payload.formId = this.formId
    payload.fileName = ""; // For upload it will taken from file name
    payload.caption = this.caption;
    const formData = new FormData();
    formData.append("file", this.files[0], this.files[0].name);
    
    this.attachmentService.upload(formData, payload, 'REPORT_IMAGE').subscribe(response => {
      if (response) {
        loader.dismiss();
        this.userdataService.presentToast("Attachment and Form Updated Successfully.", "success");
        
        if (this.attachments === undefined) {
          this.attachments = [];
        }
        this.attachments.push(response.attachmentSourceUrl);
        this.attachementEmmiter.emit(this.attachments);
        // FOR UI
        let attachmentWithUrl: any = {};
        attachmentWithUrl.url = response.attachmentSourceUrl;
        attachmentWithUrl.key = response.key;
        attachmentWithUrl.fileName = this.deriveAttachmentNameFromUrl(response.attachmentSourceUrl);
        attachmentWithUrl.caption = this.caption;
        this.attachmentsWithName.push(attachmentWithUrl);
        this.attachmentHandlingAllowed();

        this.files.splice(this.files.indexOf(this.files[0]), 1);
        this.caption = "";
      } else {
        loader.dismiss();
      }
    }, error => {
      this.userdataService.presentToast("Attachment Addition Failed.", "danger");
      loader.dismiss();
    })
    return true;
  }


  deriveAttachmentNameFromUrl(url) {
    let untillFileName = url.substring(0, url.indexOf('?'));
    let fileName = untillFileName.substring(untillFileName.lastIndexOf('/') + 1);
    return fileName;
  }

  deriveAttachmentKeyFromUrl(url) {
    let key = url.substring(url.indexOf('.com') + 5, url.indexOf('?'));
    return key;
  }

  download(attachment: any) {
    const link = document.createElement('a');
    link.href = attachment.url;
    link.setAttribute('download', attachment.fileName);
    link.setAttribute('target', '_blank');

    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  }

  attachmentHandlingAllowedDelete() {
    let status = this.formStatus;
    let allowed = false;
    if (this.createdByuserId === this.loggedInUserId) {
      if ((status === "REVERTED" || status === "RESENT" || status === "CREATED"
        || status === "RECALLED") ) {
        allowed = true;
      } else {
        allowed = false;
      }
    } else if (this.createdByuserId != this.loggedInUserId && status === 'REVERTED') {
      allowed = false;
    } else if (status === "SUBMITTED_FOR_APPROVAL" || status === "APPROVED" || status === "APPROVED_WITH_WebC"
      || status === "APPROVED_WITH_OFFICE_CO" || status === "APPROVED_WITH_WEB_AND_OFFICE"
      || status === "APPROVED_WITH_WebC_UPDATED" || status === "APPROVED_WITH_OFFICE_CO_UPDATED"
      || status === "APPROVED_WITH_WEB_AND_OFFICE_UPDATED" || status === "APPROVED_WITH_BOTH_OFFICE_UPDATED"
      || status === "APPROVED_WITH_BOTH_WebC_UPDATED") {
      allowed = false;
    } else if (status === "SHARED_WITH_WebC" || status === "SHARED_WITH_OFFICE_CO" || status === "SHARED_WITH_WEB_AND_OFFICE") {
      allowed = false;
    } else if (status === "SHARED" && this.createdByuserId === this.loggedInUserId) {
      allowed = false;
    } else if (status === "SHARED" && this.createdByuserId != this.loggedInUserId) {
      allowed = true;
    }
    return allowed;
  }

  getProfile()
    {
      this.userdataService.getUserProfile().then((profile) => {
        if (profile) {
          this.profile = profile;
          console.log(this.profile)
          if(this.profile.college.status == "SUBS_EXPIRED")
          {
            this.subscriptionStatus = false;
          }
        }
      });
    }
}
